/* ============================
   Club Login Popup
   ============================ */
// public recaptcha token
const recaptchaToken = "6LeGGbUsAAAAAJDp1hUK1FMBaxOL08wHLiJ_bOzF";

/** MaxStock app embed + server (Comax): same names as extensions/customer-phone-storefront */
const MAXSTOCK_PHONE_COOKIE_NAME = "maxstock_customer_phone";
const CART_PHONE_ATTRIBUTE_KEY = "customer_phone";
const MAXSTOCK_PHONE_COOKIE_MAX_AGE = 60 * 60 * 24 * 400;
const MAXSTOCK_APP_PROXY_BASE_DEFAULT = "/apps/maxstock";

/** Set in club-login-popup.liquid from theme setting; must match Partner app proxy subpath (not the tunnel URL). */
function getMaxstockAppProxyBase() {
  if (typeof window !== "undefined" && window.__MAXSTOCK_APP_PROXY_BASE__) {
    const configuredBase = String(window.__MAXSTOCK_APP_PROXY_BASE__).trim();
    if (!configuredBase) return MAXSTOCK_APP_PROXY_BASE_DEFAULT;

    const normalizedBase = configuredBase.replace(/\/$/, "");
    const isSafeRelativeAppsPath =
      normalizedBase.startsWith("/apps/") &&
      !normalizedBase.includes("://") &&
      !normalizedBase.includes("..");

    if (isSafeRelativeAppsPath) {
      return normalizedBase;
    }
  }
  return MAXSTOCK_APP_PROXY_BASE_DEFAULT;
}

function clubCustomerApiUrl(searchParams) {
  const base = getMaxstockAppProxyBase();
  const path = `${base}/club/customer`;
  return searchParams ? `${path}?${searchParams}` : path;
}

/**
 * @param {string} phoneDigits normalized digits (e.g. Israeli 05… without spaces/dashes)
 * @returns {Promise<void>}
 */
function persistMaxstockCustomerPhone(phoneDigits) {
  if (!phoneDigits) return Promise.resolve();

  // HttpOnly cannot be set from JavaScript; add Secure only when served over HTTPS.
  const secureAttribute = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${MAXSTOCK_PHONE_COOKIE_NAME}=${encodeURIComponent(phoneDigits)}; path=/; max-age=${MAXSTOCK_PHONE_COOKIE_MAX_AGE}; SameSite=Lax${secureAttribute}`;

  return fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      attributes: { [CART_PHONE_ATTRIBUTE_KEY]: phoneDigits },
    }),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Cart update failed (${response.status})`);
      }
      return response;
    })
    .catch((error) => {
      console.error("Failed to persist maxstock customer phone:", error);
      throw error;
    });
}
if (!customElements.get("club-login-popup")) {
  customElements.define(
    "club-login-popup",
    class ClubLoginPopup extends DrawerComponent {
      constructor() {
        super();

        this.phoneInput = this.querySelector("[data-club-phone]");
        this.submitBtn = this.querySelector("[data-club-submit]");
        this.errorEl = this.querySelector("[data-club-error]");
        this.form = this.querySelector("[data-club-form]");
      }

      get requiresBodyAppended() {
        return true;
      }

      prepareToShow() {
        this.showStep("check");
        this.hideError();
        this.setLoading(false);
      }

      openRegisterPopup(phone) {
        this.hide();
        const registerPopup = document.querySelector("club-register-popup");
        if (registerPopup) {
          registerPopup.prefillPhone(phone ?? this._cleanPhone ?? "");
          registerPopup.show();
        }
      }

      connectedCallback() {
        super.connectedCallback();

        if (this.form) {
          this.form.addEventListener("submit", this.onSubmit.bind(this));
        }

        if (this.phoneInput) {
          this.phoneInput.addEventListener("input", () => {
            this.hideError();
          });
        }
        const openRegisterBtn = this.querySelector("[data-open-register]");
        if (openRegisterBtn) {
          openRegisterBtn.addEventListener("click", () =>
            this.openRegisterPopup(),
          );
        }
        const joinBtn = this.querySelector("[data-join-btn]");
        if (joinBtn) {
          joinBtn.addEventListener("click", () => this.openRegisterPopup());
        }
        const backBtn = this.querySelector("[data-back-btn]");
        if (backBtn) {
          backBtn.addEventListener("click", () => {
            this.showStep("check");
          });
        }
      }

      onSubmit(event) {
        event.preventDefault();

        const phone = this.phoneInput?.value?.trim();

        if (!phone) {
          this.showError("נא להזין מספר טלפון");
          return;
        }

        // Basic phone validation for Israeli numbers
        const phoneRegex = /^0[0-9]{8,9}$/;
        if (!phoneRegex.test(phone.replace(/[-\s]/g, ""))) {
          this.showError("מספר טלפון לא תקין");
          return;
        }

        this.setLoading(true);
        this.hideError();

        const cleanPhone = phone.replace(/[-\s]/g, "");

        // checks with phone number in the club database
        grecaptcha.ready(() => {
          grecaptcha
            .execute(recaptchaToken, {
              action: "login",
            })
            .then((token) => {
              fetch(
                clubCustomerApiUrl(`phone=${encodeURIComponent(cleanPhone)}`),
                {
                  method: "GET",
                  headers: {
                    Accept: "application/json",
                    "X-Recaptcha-Token": token,
                  },
                },
              )
                .then((response) => {
                  if (!response.ok) {
                    throw new Error("Network response was not ok");
                  }

                  return response.json();
                })

                .then((data) => {
                  this.setLoading(false);

                  if (
                    data &&
                    (data.success || data.customer || data.is_member)
                  ) {
                    document.cookie =
                      "isUserLoggedIn=true; path=/; max-age=" +
                      60 * 60 * 48 +
                      "; SameSite=Lax";

                    localStorage.setItem(
                      "isUserLoggedIn",
                      JSON.stringify({
                        phone: cleanPhone,

                        success: true,
                      }),
                    );

                    persistMaxstockCustomerPhone(cleanPhone).finally(() => {
                      this.hide();
                      window.location.href = "/checkout";
                    });
                  } else {
                    /* wedev - start: GA4 popup_view — phone not a club member (API success, not registered) */
                    gtag("event", "popup_view", { popup_name: "max_friends_popup" });
                    /* wedev - end */
                    this.openRegisterPopup(cleanPhone);
                  }
                })
                .catch((error) => {
                  this.setLoading(false);
                  console.error("Club login error:", error);
                  this._cleanPhone = cleanPhone;
                  /* wedev - start: GA4 popup_view — login fetch error / not-member step */
                  gtag("event", "popup_view", { popup_name: "max_friends_popup" });
                  /* wedev - end */
                  this.showStep("not-member");
                });
            })
            .catch((error) => {
              this.setLoading(false);
              console.error("Club login error:", error);
              this.showError("אירעה שגיאה, נסו שוב מאוחר יותר");
            });
        });
      }
      showStep(step) {
        this.querySelectorAll("[data-step]").forEach((el) => {
          const isActive = el.dataset.step === step;
          el.hidden = !isActive;
        });
        this.classList.toggle("club-login-popup--not-member", step === "not-member");
      }
      showError(message) {
        if (this.errorEl) {
          this.errorEl.textContent = message;
          this.errorEl.classList.add("is-visible");
        }
      }

      hideError() {
        if (this.errorEl) {
          this.errorEl.classList.remove("is-visible");
        }
      }

      setLoading(isLoading) {
        if (isLoading) {
          this.submitBtn?.setAttribute("disabled", "disabled");
        } else {
          this.submitBtn?.removeAttribute("disabled");
        }
      }
    },
  );
}

/** @param {string} value */
function formatRegisterDobInput(value) {
  const digits = value.replace(/\D/g, "").slice(0, 8);
  if (digits.length <= 2) return digits;
  if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`;
  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
}

/** @param {string} value dd/mm/yyyy */
function parseRegisterDobToIso(value) {
  const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value.trim());
  if (!match) return null;

  const day = Number(match[1]);
  const month = Number(match[2]);
  const year = Number(match[3]);
  const date = new Date(year, month - 1, day);

  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return null;
  }

  return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
}

/* ============================
   Club Registration Popup
   ============================ */
if (!customElements.get("club-register-popup")) {
  customElements.define(
    "club-register-popup",
    class ClubRegisterPopup extends DrawerComponent {
      constructor() {
        super();

        this.form = this.querySelector("[data-club-register-form]");
        this.nameInput = this.querySelector("[data-register-name]");
        this.dobInput = this.querySelector("[data-register-dob]");
        this.idInput = this.querySelector("[data-register-id]");
        this.phoneInput = this.querySelector("[data-register-phone]");
        this.emailInput = this.querySelector("[data-register-email]");
        this.consentCheckbox = this.querySelector("[data-register-consent]");
        this.submitBtn = this.querySelector("[data-register-submit]");
        this.errorEl = this.querySelector("[data-register-error]");
      }

      get requiresBodyAppended() {
        return true;
      }

      connectedCallback() {
        super.connectedCallback();

        if (this.form) {
          this.form.addEventListener("submit", this.onSubmit.bind(this));
        }

        // Clear errors on input
        const inputs = this.querySelectorAll(
          ".club-register-popup__input, .club-register-popup__dob-input, .club-register-popup__email-input, .club-register-popup__consent-checkbox",
        );
        inputs.forEach((input) => {
          input.addEventListener("input", () => this.clearFieldErrorForInput(input));
          input.addEventListener("change", () => this.clearFieldErrorForInput(input));
        });

        if (this.dobInput) {
          this.dobInput.addEventListener("input", this.onDobInput.bind(this));
        }
      }

      onDobInput(event) {
        const input = event.currentTarget;
        if (!(input instanceof HTMLInputElement)) return;

        const formatted = formatRegisterDobInput(input.value);
        if (input.value !== formatted) {
          input.value = formatted;
        }
      }

      prefillPhone(phone) {
        if (this.phoneInput) {
          this.phoneInput.value = phone;
        }
      }

      onSubmit(event) {
        event.preventDefault();

        const name = this.nameInput?.value?.trim();
        const dateOfBirth = parseRegisterDobToIso(this.dobInput?.value ?? "");
        const idCard = this.idInput?.value?.trim();
        const phone = this.phoneInput?.value?.trim();
        const email = this.emailInput?.value?.trim();
        const consent = this.consentCheckbox?.checked;

        // Validation
        this.hideFieldErrors();
        this.hideFormError();

        if (!name) {
          this.showFieldError("name", "נא להזין שם מלא");
          return;
        }

        if (!dateOfBirth) {
          this.showFieldError("dob", "נא להזין תאריך לידה תקין (dd/mm/yyyy)");
          return;
        }

        if (!idCard) {
          this.showFieldError("id", "נא להזין תעודת זהות");
          return;
        }

        if (!phone) {
          this.showFieldError("phone", "נא להזין מספר טלפון");
          return;
        }

        if (!email) {
          this.showFieldError("email", "נא להזין כתובת מייל");
          return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
          this.showFieldError("email", "כתובת מייל לא תקינה");
          return;
        }

        if (!consent) {
          this.showFieldError("consent", "יש לאשר קבלת דיוור כדי להמשיך");
          return;
        }

        this.setLoading(true);
        this.hideFieldErrors();
        this.hideFormError();

        // does registration as a club member
        grecaptcha.ready(() => {
          grecaptcha
            .execute(recaptchaToken, { action: "register" })
            .then((token) => {
              fetch(clubCustomerApiUrl(), {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Accept: "application/json",
                  "X-Recaptcha-Token": token,
                },
                body: JSON.stringify({
                  name,
                  dateOfBirth,
                  idCard,
                  phone: phone.replace(/[-\s]/g, ""),
                  email,
                }),
              })
                .then((response) => {
                  if (!response.ok) {
                    throw new Error("Network response was not ok");
                  }
                  return response.json();
                })
                .then((data) => {
                  this.setLoading(false);

                  if (
                    data &&
                    (data.customerId ||
                      data.ID ||
                      data.InternalID ||
                      data.id ||
                      data.internalId)
                  ) {
                    /* wedev - start: GA4 registration success (server confirmed member id) */
                    gtag("event", "max_member_registration_click", {
                      button_location: "popup",
                    });
                    /* wedev - end */

                    document.cookie =
                      "isUserLoggedIn=true; path=/; max-age=" +
                      60 * 60 * 48 +
                      "; SameSite=Lax";

                    const registeredPhone = phone.replace(/[-\s]/g, "");

                    localStorage.setItem(
                      "isUserLoggedIn",
                      JSON.stringify({
                        phone: registeredPhone,
                        success: true,
                        id: data.ID || data.id,
                        internalId: data.InternalID || data.internalId,
                      }),
                    );

                    persistMaxstockCustomerPhone(registeredPhone).finally(() => {
                      this.hide();
                      window.location.href = "/checkout";
                    });
                  } else {
                    this.showFormError(
                      data?.message || "אירעה שגיאה בהרשמה, נסו שוב",
                    );
                  }
                })
                .catch((error) => {
                  this.setLoading(false);
                  console.error("Club registration error:", error);
                  this.showFormError("אירעה שגיאה, נסו שוב מאוחר יותר");
                });
            })
            .catch((error) => {
              this.setLoading(false);
              console.error("Club registration error:", error);
              this.showFormError("אירעה שגיאה, נסו שוב מאוחר יותר");
            });
        });
      }

      getFieldErrorEl(fieldKey) {
        return this.querySelector(`[data-field-error="${fieldKey}"]`);
      }

      getFieldContainer(fieldKey) {
        const errorEl = this.getFieldErrorEl(fieldKey);
        if (!errorEl) return null;
        if (fieldKey === "consent") {
          return errorEl.closest(".club-register-popup__consent-wrap");
        }
        return errorEl.closest(".club-register-popup__field");
      }

      showFieldError(fieldKey, message) {
        this.hideFieldErrors();
        this.hideFormError();

        const errorEl = this.getFieldErrorEl(fieldKey);
        const fieldContainer = this.getFieldContainer(fieldKey);

        if (errorEl) {
          errorEl.textContent = message;
          errorEl.classList.add("is-visible");
        }

        if (fieldContainer) {
          fieldContainer.classList.add("club-register-popup__field--has-error");
        }

        if (fieldKey === "consent") {
          const consentLabel = this.querySelector(
            ".club-register-popup__consent-label",
          );
          consentLabel?.classList.add("has-error");
        }
      }

      hideFieldErrors() {
        this.querySelectorAll(".club-register-popup__field-error").forEach(
          (errorEl) => {
            errorEl.textContent = "";
            errorEl.classList.remove("is-visible");
          },
        );

        this.querySelectorAll(".club-register-popup__field--has-error").forEach(
          (fieldEl) => {
            fieldEl.classList.remove("club-register-popup__field--has-error");
          },
        );

        const consentLabel = this.querySelector(
          ".club-register-popup__consent-label",
        );
        consentLabel?.classList.remove("has-error");
      }

      clearFieldErrorForInput(input) {
        if (!(input instanceof HTMLElement)) return;

        const fieldError = input.closest(
          ".club-register-popup__field, .club-register-popup__consent-wrap",
        )?.querySelector(".club-register-popup__field-error");

        if (fieldError?.classList.contains("is-visible")) {
          this.hideFieldErrors();
        }

        this.hideFormError();
      }

      showFormError(message) {
        this.hideFormError();
        if (this.errorEl) {
          this.errorEl.textContent = message;
          this.errorEl.classList.add("is-visible");
        }
      }

      hideFormError() {
        if (this.errorEl) {
          this.errorEl.textContent = "";
          this.errorEl.classList.remove("is-visible");
        }
      }

      setLoading(isLoading) {
        if (isLoading) {
          this.submitBtn?.setAttribute("disabled", "disabled");
        } else {
          this.submitBtn?.removeAttribute("disabled");
        }
      }
    },
  );
}

/* ============================
   Checkout Interception Logic
   ============================ */
function getCookieValue(name) {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? match[2] : null;
}

function isClubMember() {
  return getCookieValue("isUserLoggedIn") === "true";
}

function showClubLoginPopup() {
  const popup = document.querySelector("club-login-popup");
  if (popup) {
    popup.show();
  }
}

function blockCheckoutAndShowPopup(event) {
  if (isClubMember()) {
    return;
  }

  event.preventDefault();
  event.stopPropagation();
  showClubLoginPopup();
}

function handleCheckoutClick(event) {
  const checkoutBtn = event.target.closest("[data-club-checkout-btn]");
  if (!checkoutBtn) return;

  blockCheckoutAndShowPopup(event);
}

function handleCartFormSubmit(event) {
  const form = event.target;
  if (!(form instanceof HTMLFormElement)) return;

  const submitter = event.submitter;
  const isCheckoutSubmit =
    submitter?.name === "checkout" ||
    (submitter instanceof Element && 
      submitter.hasAttribute("data-club-checkout-btn"));

  if (!isCheckoutSubmit) return;

  blockCheckoutAndShowPopup(event);
}

document.addEventListener("DOMContentLoaded", () => {
  document.addEventListener("click", handleCheckoutClick, true);
  document.addEventListener("submit", handleCartFormSubmit, true);
});